import i18n from 'modules/core/lib/i18n'
import moment from 'moment'

export const formatTripSummary = (startDate: Date, endDate: Date) => {
  const start = moment(startDate).startOf('day')
  const end = moment(endDate).startOf('day')

  const days = end.diff(start, 'days') + 1
  const nights = Math.max(0, days - 1)

  const daysLabel = i18n.tp('expenses_v2.forms.germany_per_diem_modal.trip_details.days', {
    count: days,
  })
  const nightsLabel = i18n.tp('expenses_v2.forms.germany_per_diem_modal.trip_details.nights', {
    count: nights,
  })
  return i18n.t('expenses_v2.forms.germany_per_diem_modal.trip_details.trip_summary_label', {
    days: days,
    nights: nights,
    daysLabel,
    nightsLabel,
  })
}
